var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThird(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_839_294)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_839_294)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_839_294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44 0H16C7.16344 0 0 7.16344 0 16V44C0 52.8366 7.16344 60 16 60H44C52.8366 60 60 52.8366 60 44V16C60 7.16344 52.8366 0 44 0Z",
    fill: "#F1CAFF"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M18.2 27.14C18.2667 25.8067 18.7333 24.78 19.6 24.06C20.48 23.3267 21.6333 22.96 23.06 22.96C24.0333 22.96 24.8667 23.1333 25.56 23.48C26.2533 23.8133 26.7733 24.2733 27.12 24.86C27.48 25.4333 27.66 26.0867 27.66 26.82C27.66 27.66 27.44 28.3733 27 28.96C26.5733 29.5333 26.06 29.92 25.46 30.12V30.2C26.2333 30.44 26.8333 30.8667 27.26 31.48C27.7 32.0933 27.92 32.88 27.92 33.84C27.92 34.64 27.7333 35.3533 27.36 35.98C27 36.6067 26.46 37.1 25.74 37.46C25.0333 37.8067 24.18 37.98 23.18 37.98C21.6733 37.98 20.4467 37.6 19.5 36.84C18.5533 36.08 18.0533 34.96 18 33.48H20.72C20.7467 34.1333 20.9667 34.66 21.38 35.06C21.8067 35.4467 22.3867 35.64 23.12 35.64C23.8 35.64 24.32 35.4533 24.68 35.08C25.0533 34.6933 25.24 34.2 25.24 33.6C25.24 32.8 24.9867 32.2267 24.48 31.88C23.9733 31.5333 23.1867 31.36 22.12 31.36H21.54V29.06H22.12C24.0133 29.06 24.96 28.4267 24.96 27.16C24.96 26.5867 24.7867 26.14 24.44 25.82C24.1067 25.5 23.62 25.34 22.98 25.34C22.3533 25.34 21.8667 25.5133 21.52 25.86C21.1867 26.1933 20.9933 26.62 20.94 27.14H18.2Z",
    fill: "#2A2A2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5809 25.2642C31.7969 24.9122 32.0769 24.6362 32.4209 24.4362C32.7729 24.2362 33.1729 24.1362 33.6209 24.1362V25.9002H33.1769C32.6489 25.9002 32.2489 26.0242 31.9769 26.2722C31.7129 26.5202 31.5809 26.9522 31.5809 27.5682V30.8802H29.9009V24.2322H31.5809V25.2642Z",
    fill: "#2A2A2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6802 27.532C34.6802 26.86 34.8122 26.264 35.0762 25.744C35.3482 25.224 35.7162 24.824 36.1802 24.544C36.6442 24.264 37.1602 24.124 37.7282 24.124C38.1602 24.124 38.5722 24.22 38.9642 24.412C39.3562 24.596 39.6682 24.844 39.9002 25.156V22H41.6042V30.88H39.9002V29.896C39.6922 30.224 39.4002 30.488 39.0242 30.688C38.6482 30.888 38.2122 30.988 37.7162 30.988C37.1562 30.988 36.6442 30.844 36.1802 30.556C35.7162 30.268 35.3482 29.864 35.0762 29.344C34.8122 28.816 34.6802 28.212 34.6802 27.532ZM39.9122 27.556C39.9122 27.148 39.8322 26.8 39.6722 26.512C39.5122 26.216 39.2962 25.992 39.0242 25.84C38.7522 25.68 38.4602 25.6 38.1482 25.6C37.8362 25.6 37.5482 25.676 37.2842 25.828C37.0202 25.98 36.8042 26.204 36.6362 26.5C36.4762 26.788 36.3962 27.132 36.3962 27.532C36.3962 27.932 36.4762 28.284 36.6362 28.588C36.8042 28.884 37.0202 29.112 37.2842 29.272C37.5562 29.432 37.8442 29.512 38.1482 29.512C38.4602 29.512 38.7522 29.436 39.0242 29.284C39.2962 29.124 39.5122 28.9 39.6722 28.612C39.8322 28.316 39.9122 27.964 39.9122 27.556Z",
    fill: "#2A2A2B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_839_294",
    x: -3,
    y: -3,
    width: 66,
    height: 66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_839_294"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_839_294",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_839_294",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_839_294"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_839_294"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThird);
export default __webpack_public_path__ + "static/media/third.2db301478fe618d334fb6039bd5fd7c7.svg";
export { ForwardRef as ReactComponent };